package screens.static

import common.EConstants
import components.Toolbar
import components.burgerMenu.BurgerMenu
import core.ionic.IonContent
import core.ionic.IonHeader
import core.ionic.IonPage
import csstype.pct
import csstype.px
import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML.iframe

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 04.11.22
 * Author : leonhergt
 */

external interface ShowImprintScreenProps: Props {}

val ShowImprintScreen = FC<ShowImprintScreenProps> {
    IonPage {
        id = EConstants.BURGER_MENU_CONTENT.mId

        IonHeader {
            Toolbar() {
                mIsBackNavigation = true
            }
        }
        IonContent {
            iframe {
                css {
                    height = 100.pct
                    width = 100.pct
                    border = 0.px
                }
                id = "colourOnWallIframe"

                src = "https://imprint.daw.de/api/v1/291/de/html"
            }
        }
    }
    BurgerMenu()
}